<template>
  <div class="content">
    <p class="orange">未来基因（北京）人工智能研究院</p>
    <p>基于</p>
    <p class="orange">2022年教育部颁布的《义务教育阶段信息科技课程标准》
    <p>研发的</p>
    <p class="orange">FutureAI </p>
    <p class="orange">信息科技核心素养评价系统</p>
    <p class="orange">上线啦！</p>
    <img style="width:677px" src="../assets/join/1.png" alt="">
    <img src="../assets/join/2.png" alt="">
    <p>欢迎广大信息科技教师</p>
    <p>申请免费试用</p>
    <p class="orange">-----【免费试用】-----</p>
    <img style="width:151px;" src="../assets/join/3.png" alt="">
    <p>我们将为您<span class="orange">提供教学评价服务</span></p>
    <p>即刻<span class="orange">开始体验</span></p>
    <p class="orange">FutureAI </p>
    <p class="orange">信息科技核心素养评价系统</p>
    <img src="../assets/join/4.png" alt="">
  </div>
</template>

<script>
export default {

}
</script>

<style>
.content{
    text-align: center;
    font-size: 16px;
    font-weight: bold;
}
.orange{
    color: rgb(254, 117, 0);
}
</style>